import { Building } from '../building/model/building.model';
import { User } from './model/user.model';
import { selectHasPolicy } from './store/user.selector';


export const authorization = (store, user?: User) => ({
  authorizedForBuilding: (building?: Building): boolean => {
    if (!building || !user) {
      return false;
    }

    let isAuthorized = false;

    const buildingContextValue = building.layerContexts.find(lc => lc.name === 'layer_context_1')?.value;

    store.select(selectHasPolicy('building.files.get')).subscribe((hasPolicy: boolean) => {
      isAuthorized =
        hasPolicy ||
        (
          user.activeRole === 'role_scpi' && user.roleContextValues.some(
            roleContext =>
              roleContext.roleCode === 'role_scpi' &&
              buildingContextValue !== undefined &&
              roleContext.contextValues.includes(buildingContextValue)
          ))
        ||
        (
          user.activeRole === 'role_administration_communal' && user.roleContextValues.some(
            roleContext =>
              roleContext.roleCode === 'role_administration_communal' &&
              buildingContextValue !== undefined &&
              roleContext.contextValues.includes(buildingContextValue)
          ))
        ||
        (
          user.activeRole === 'role_prefecture' && user.roleContextValues.some(
            roleContext =>
              roleContext.roleCode === 'role_prefecture' &&
              buildingContextValue !== undefined &&
              roleContext.contextValues.includes(buildingContextValue)
          ))
        ||
        user.activeRole === 'role_cecb';
    }).unsubscribe();

    return isAuthorized;
  }
});
